// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/service/v1/service.proto (package stailer_service_specification.service.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/service/v1/service.proto.
 */
const file_stailer_service_specification_service_v1_service = /*@__PURE__*/
  fileDesc("CjZzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9zZXJ2aWNlL3YxL3NlcnZpY2UucHJvdG8SKHN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLnNlcnZpY2UudjEilAIKB1NlcnZpY2USVAoEbmFtZRgBIAEoCUJGkoIZJ+OCteODvOODk+OCueOBruWQjeWJjeOCkuaMh+WumuOBl+OBvuOBmaqCGQ/jgrXjg7zjg5PjgrnlkI24ghkCyIIZARKyAQoKc2hvcnRfbmFtZRgCIAEoCUKdAZKCGXjjgrXjg7zjg5Pjgrnjga7nn63nuK7lkI3jgpLmjIflrprjgZfjgb7jgZnjgILnrqHnkIbnlLvpnaLjgarjganjgafjgrnjg5rjg7zjgrnjgYzpmZDjgonjgozjgovloLTlkIjjgavkvb/nlKjjgZXjgozjgb7jgZmqghkV44K144O844OT44K555+t57iu5ZCNuIIZAsiCGQFiBnByb3RvMw", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.service.v1.Service.
 * Use `create(ServiceSchema)` to create a new message.
 */
const ServiceSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_service_v1_service, 0);


exports.file_stailer_service_specification_service_v1_service = file_stailer_service_specification_service_v1_service;
exports.ServiceSchema = ServiceSchema;
